import { useTranslation } from "react-i18next";
import MuiDrawer from "@mui/material/Drawer";
import Grid from "@/config/Grid/Grid";
import IconButton from "@/components/IconButton/IconButton";
import WaiterAvatar from "@/components/WaiterAvatar/WaiterAvatar";
import { drawerStyles } from "@/components/Drawer/Drawer.styles";
import drawerCss from "@/components/Drawer/Drawer.module.scss";
import type { Waiter } from "@/api/Waiters/WaitersAPI.model";
import styles from "./WaiterDrawer.module.scss";

interface WaiterDrawerProps {
  open: boolean;
  waiters: Waiter[];
  onSelect: (waiter: Waiter) => void;
  onClose: () => void;
}

/**
 * Who the guest wants to thank, as a wall of faces.
 *
 * A name alone is no help to someone who never caught it. The photo is what
 * the guest actually recognises, so it leads and the name follows it. Closing
 * without choosing is a valid answer: the tip then goes to the team.
 */
function WaiterDrawer(props: WaiterDrawerProps) {
  const { open, waiters, onSelect, onClose } = props;
  const { t } = useTranslation();

  return (
    <MuiDrawer sx={drawerStyles} anchor="bottom" open={open} onClose={onClose}>
      <Grid>
        <div
          className={`start-1 col-4 align-start ${drawerCss.drawerLayoutWrapper}`}
        >
          <div className={drawerCss.drawerLayoutHeader}>
            <IconButton
              iconName="las la-angle-left icon-big"
              onClick={onClose}
              color="primary"
            />
            <p className={`body-bold-large ${drawerCss.drawerLayoutTitle}`}>
              {t("tip.waiter.title")}
            </p>
            <IconButton
              iconName=""
              onClick={() => {}}
              color="primary"
              variant="text"
            />
          </div>

          <div className={styles.waiterGrid}>
            {waiters.map((waiter) => (
              <div
                key={waiter.userId}
                className={styles.waiterTile}
                onClick={() => onSelect(waiter)}
                role="button"
                tabIndex={0}
                onKeyDown={(event) => {
                  if (event.key === "Enter" || event.key === " ") {
                    event.preventDefault();
                    onSelect(waiter);
                  }
                }}
              >
                <WaiterAvatar name={waiter.name} photoUrl={waiter.photoUrl} />
                <p className={`body-bold-medium ${styles.waiterTileName}`}>
                  {waiter.name}
                </p>
              </div>
            ))}
          </div>
        </div>
      </Grid>
    </MuiDrawer>
  );
}

export default WaiterDrawer;
